var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7A91C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3828 30H21.7578V18.6334L16.8243 10H12.3828V30Z",
    fill: "#F7A91C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 14.6875C25.6583 14.6875 26.4453 13.9005 26.4453 12.9297C26.4453 11.9589 25.6583 11.1719 24.6875 11.1719C23.7167 11.1719 22.9297 11.9589 22.9297 12.9297C22.9297 13.9005 23.7167 14.6875 24.6875 14.6875Z",
    fill: "#F7A91C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6172 19.332C27.0316 20.1194 26.3795 20.7373 25.2734 21.222V29.9992H27.6172V19.332Z",
    fill: "#F7A91C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9297 20.5469C25.5132 20.5469 27.6534 18.437 27.6166 15.7924C27.58 15.1727 27.0656 14.6875 26.4453 14.6875C25.7993 14.6875 25.2734 15.2134 25.2734 15.8594C25.2734 17.152 24.2223 18.2031 22.9297 18.2031V20.5469Z",
    fill: "#F7A91C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtm);
export default __webpack_public_path__ + "static/media/atm.c3b9441790b7b9ab9147bf5b854621ae.svg";
export { ForwardRef as ReactComponent };